jQuery( function ( $ ) {
	$( document ).on(
		'click',
		'.icon-menu > a, .secondary-menu .close-button',
		function ( e ) {
			e.preventDefault();
			$( 'body' ).toggleClass( 'open-menu' );
		}
	);

	$( document ).on(
		'click',
		'.icon-search > a, .search-form-wrapper .close-button',
		function ( e ) {
			e.preventDefault();
			const body = $( 'body' );
			$( body ).toggleClass( 'open-search' );

			if ( $( body ).hasClass( 'open-search' ) ) {
				$( '.search-form .search-field' ).focus();
			}
		}
	);

	$( document ).on( 'click', '.single-faq-item .question a', function ( e ) {
		e.preventDefault();
		const parent = $( this ).closest( '.single-faq-item' );
		$( parent ).toggleClass( 'open' );
		$( parent ).find( '.answer' ).slideToggle();
	} );

	$( document ).on( 'click', '.dealer-parent-category', function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'open' );
		$( this ).siblings( '.children' ).slideToggle();
		//mm_maps.map.map.setCenter({lat:0, lng:0})
	} );

	$( '.maksimer-map-search-form' ).submit( function ( e ) {
		e.preventDefault();
		$( 'body' ).animate( { scrollTop: 0 }, 700 );
	} );
	 

	/**
	 * Active marker change of icon on category list anchor click event.
	 */
	document.addEventListener('click', (e) => {
		const location = e.target.closest('.map-location-link');

		if (!location) {
			return;
		}

        if (location === e.target || location.contains(e.target)) {
            e.preventDefault();
			
			document.body.scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest"
			});

			const lat = parseFloat(location.getAttribute( 'data-lat' ));
			const lng = parseFloat(location.getAttribute( 'data-lng' ));

			mm_maps.map.map.setCenter( { lat, lng } );
			mm_maps.map.map.setZoom( 15 );

			if (!mm_maps.map.markers) {
				return;
			}

			const anchorPosition = `${lat} - ${lng}`;

			mm_maps.map.markers.forEach(marker => {
				const markerPosition = `${marker.getPosition().lat()} - ${marker.getPosition().lng()}`;

				const icon = `${location.origin}/wp-content/themes/astra-child/assets/images/marker-icon-alt.png`;
				marker.setIcon();

				if (anchorPosition === markerPosition) {
					marker.setIcon(icon);
					return;
				}
			});
        }
	});
} );
